import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import classNames from 'classnames';

import { SUBSCRIBER_PATH, GUEST_PATH, MODAL_LOGIN, POPUP_REGISTER, MY_LEARNING_PATH } from '../../constants';
import images from '../../assets/images';

import SubscriberAccountDropdown from './TheAccountDropdown';
import LoginModal from '../../components/Auth/LoginModal';
import RegisterModal from '../../components/Auth/RegisterModal';

import { setSidebarShow, toggleTheme } from '../../actions/general';
import { useOutsideHandling } from '../../utils';
import { CartInfo } from '../../components/CMS/Guest/Cart/CartInfo';

const SubscriberHeader = () => {
     const location = useLocation();

     const wrapperRef = useRef(null);

     const show = useSelector((state) => state.general.show);

     const [showSetting, setShowSetting] = useState(false);
     const [showMenuMB, setShowMenuMB] = useState(false);
     const [isMobile, setIsMobile] = useState(false);

     const locationPath = location.pathname;

     const paramMyLearning = locationPath === MY_LEARNING_PATH.DASHBOARD;

     const handleClickMenuMB = () => {
          setShowMenuMB(!showMenuMB);
          setShowSetting(false);
     };

     const handClickSetting = () => {
          setShowSetting(!showSetting);
          setShowMenuMB(false);
     };

     const clickOutside = useCallback(() => {
          setShowSetting(false);
     }, []);

     useOutsideHandling(wrapperRef, clickOutside);

     useEffect(() => {
          if (showMenuMB) {
               document.querySelector('body').classList.add('no-scroll-body');
          } else {
               document.querySelector('body').classList.remove('no-scroll-body');
          }

          const handleResize = () => {
               if (window.innerWidth > 1140) {
                    setShowMenuMB(false);
               }
          };

          window.addEventListener('resize', handleResize);

          return () => {
               window.removeEventListener('resize', handleResize);
          };
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     useEffect(() => {
          const handleResize = () => {
               setIsMobile(window.innerWidth <= 1199);
          };

          window.addEventListener('resize', handleResize);

          handleResize();

          return () => {
               window.removeEventListener('resize', handleResize);
          };
     }, []);

     return (
          <>
               <header>
                    <div className="header-main">
                         <div className="container-wrapper">
                              <div className="header-main-wrapper">
                                   <div className="header-left">
                                        <div className="header-logo">
                                             <Link
                                                  to={MY_LEARNING_PATH.DASHBOARD}
                                                  className={classNames('header-link', { disabled: paramMyLearning })}
                                             >
                                                  <img src={images.logoMain} alt="Logo" className="header-img" />
                                             </Link>
                                        </div>
                                        <div className="header-title">
                                             <Link to={MY_LEARNING_PATH.DASHBOARD} className={classNames({ disabled: paramMyLearning })}>
                                                  Learning Center
                                             </Link>
                                        </div>
                                   </div>

                                   <div className={`menu-mb${showMenuMB ? ' d-block' : ''}`}>
                                        <ul>
                                             <div className="header-title">
                                                  <Link to={MY_LEARNING_PATH.DASHBOARD} className={classNames({ disabled: paramMyLearning })}>
                                                       Learning Center
                                                  </Link>
                                             </div>

                                             <li className="mb-item">
                                                  <div className="purchase-link">
                                                       <Link to={GUEST_PATH.SELLING_GROUPS}>Purchase Training</Link>
                                                  </div>
                                             </li>

                                             <li className="mb-item">
                                                  <div className="learning-control">
                                                       <p className="learning-select-label">Personal training account for</p>
                                                       <div className="learning-select">{isMobile && <SubscriberAccountDropdown />}</div>
                                                  </div>
                                             </li>
                                        </ul>
                                   </div>

                                   <div className="header-content header-subscriber">
                                        <div className="header-right">
                                             <div className="learning-control mb-show">
                                                  <div className="purchase-link">
                                                       <div
                                                            className="cart-link"
                                                            onClick={() => {
                                                                 setShowMenuMB(false);
                                                            }}
                                                       >
                                                            <CartInfo />
                                                       </div>
                                                  </div>
                                             </div>

                                             <div className={`toggle-btn${showMenuMB ? ' close' : ''}`} onClick={handleClickMenuMB}></div>

                                             <div className="learning-control">
                                                  <div className="purchase-link">
                                                       <div
                                                            className="cart-link"
                                                            onClick={() => {
                                                                 setShowMenuMB(false);
                                                            }}
                                                       >
                                                            <CartInfo />
                                                       </div>
                                                       <Link to={GUEST_PATH.SELLING_GROUPS}>Purchase Training</Link>
                                                  </div>
                                                  <p className="learning-select-label">Personal training account for</p>
                                                  <div className="learning-select">
                                                       <SubscriberAccountDropdown />
                                                  </div>
                                                  <div ref={wrapperRef} className="setting-icon">
                                                       <img src={images.settingIcon} alt="Setting Icon" onClick={handClickSetting} />
                                                       <div ref={wrapperRef} className={`setting-menu-popup${showSetting ? ' d-block' : ''}`}>
                                                            <ul>
                                                                 <li>
                                                                      <Link to={SUBSCRIBER_PATH.MY_ACCOUNT_SETTINGS}>Account Settings</Link>
                                                                 </li>
                                                                 <li>
                                                                      <Link to={SUBSCRIBER_PATH.MY_PURCHASES}>Purchases & Billing</Link>
                                                                 </li>
                                                                 <li>
                                                                      <Link to={SUBSCRIBER_PATH.ORGANIZATION}>My Training Teams</Link>
                                                                 </li>
                                                            </ul>
                                                       </div>
                                                  </div>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </header>

               {show === MODAL_LOGIN && <LoginModal />}
               {show === POPUP_REGISTER && <RegisterModal />}
          </>
     );
};

const mapStateToProps = (state) => {
     return {
          general: state.general,
          subscriber: state.subscriber,
     };
};

const mapDispatchToProps = {
     toggleTheme,
     setSidebarShow,
};

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(SubscriberHeader));
